/**
 * Vertical thumbnail column (PDP): scroll by one thumbnail based on
 * whether the click is in the upper or lower half of currently visible items.
 * - Lower half → scroll down (reveal lower thumbnails)
 * - Upper half → scroll up (reveal upper thumbnails)
 */
(function () {
  const DESKTOP_MQ = window.matchMedia('(min-width: 750px)');

  function isItemInDom(item) {
    if (!item || item.classList.contains('fn-variant-media--hidden')) return false;
    const style = window.getComputedStyle(item);
    return style.display !== 'none' && style.visibility !== 'hidden';
  }

  function intersectsViewport(item, listRect) {
    const rect = item.getBoundingClientRect();
    return rect.bottom > listRect.top + 1 && rect.top < listRect.bottom - 1;
  }

  function getScrollStep(list, item) {
    const styles = window.getComputedStyle(list);
    const gap = parseFloat(styles.rowGap || styles.gap) || 0;
    return item.getBoundingClientRect().height + gap;
  }

  function onDocumentClick(event) {
    if (!DESKTOP_MQ.matches) return;

    const button = event.target.closest('.product--thumbnail .thumbnail-list__item button');
    if (!button) return;

    const item = button.closest('.thumbnail-list__item');
    const list = button.closest('.thumbnail-list');
    if (!item || !list) return;
    if (list.scrollHeight <= list.clientHeight + 1) return;

    const listRect = list.getBoundingClientRect();
    const visibleItems = Array.from(list.querySelectorAll('.thumbnail-list__item')).filter(
      (el) => isItemInDom(el) && intersectsViewport(el, listRect)
    );
    if (visibleItems.length < 2) return;

    const indexInVisible = visibleItems.indexOf(item);
    if (indexInVisible < 0) return;

    const mid = Math.floor(visibleItems.length / 2);
    const step = getScrollStep(list, item);
    if (step <= 0) return;

    const maxScroll = list.scrollHeight - list.clientHeight;
    const delta = indexInVisible >= mid ? step : -step;
    const nextTop = Math.min(maxScroll, Math.max(0, list.scrollTop + delta));
    if (Math.abs(nextTop - list.scrollTop) < 1) return;

    list.scrollTo({ top: nextTop, behavior: 'smooth' });
  }

  document.addEventListener('click', onDocumentClick);
})();
